function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import PropTypes from "prop-types";
import React, { Component } from "react";
import { SearchDriver } from "@elastic/search-ui";
import SearchContext from "./SearchContext";
/**
 * The SearchProvider primarily holds a reference to the SearchDriver and
 * exposes it to the rest of the application in a Context.
 */

var SearchProvider =
/*#__PURE__*/
function (_Component) {
  _inherits(SearchProvider, _Component);

  function SearchProvider() {
    var _this;

    _classCallCheck(this, SearchProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchProvider).call(this));
    _this.state = {
      driver: null
    };
    return _this;
  }

  _createClass(SearchProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var config = this.props.config; // This initialization is done inside of componentDidMount, because initializing the SearchDriver server side
      // will error out, since the driver depends on window. Placing the initialization inside of componentDidMount
      // assures that it won't attempt to initialize server side.

      var driver = new SearchDriver(config);
      this.setState({
        driver: driver
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.state.driver.tearDown();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children; // Since driver is initialized in componentDidMount above, we are waiting
      // to render until the driver is available.

      if (!this.state.driver) return null; // Passing the entire "this.state" to the Context is significant. Because
      // Context determines when to re-render based on referential identity
      // something like this could cause unnecessary renders:
      //
      // <SearchContext.Provider value={{driver: this.state.driver}}>
      //
      // By passing the entire state, we ensure that re-renders only occur when
      // state is actually updated.

      return React.createElement(SearchContext.Provider, {
        value: this.state
      }, children);
    }
  }]);

  return SearchProvider;
}(Component);

_defineProperty(SearchProvider, "propTypes", {
  children: PropTypes.node.isRequired,
  // Not providing a shape here because the shape matches the shape of
  // SearchDriver. SearchDriver can do it's own parameter validation.
  config: PropTypes.object
});

export default SearchProvider;